<template>
  <div class="fixed top-0 left-0 right-0 z-50">
    <el-menu
      :default-active="active"
      class="el-menu-demo flex"
      mode="horizontal"
      background-color="#112f66"
      text-color="#fff"
      active-text-color="#e58d36"
      @select="handleSelect"
    >
      <div class="flex ml-6 items-center">
        <!-- <a
          class="flex items-center"
          href="https://www.cargosoon.com/"
          target="_blank"
        >
          <img
            src="@/assets/cargosoonLogo1.png"
            class="h-8 mr-1 hidden sm:block"
            alt=""
          />
          <img
            src="@/assets/cargosoonLogo2.png"
            class="h-6"
            alt=""
          />
        </a> -->
        
        <a
          class="flex items-center"
          href="/"
          target="_blank"
        >
          <img
            src="@/assets/logo/co-logistics.png"
            class="h-10"
            alt=""
          />
        </a>

        <div class="mx-3">
          <el-input
            v-model="sinput"
            size="small"
            placeholder="Please input"
            prefix-icon="el-icon-search"
          />
        </div>
      </div>
      <el-menu-item index="/new/">Home</el-menu-item>

      <el-submenu index="2">
        <template #title>Quote</template>
        <!-- <el-menu-item index="/main/booking">DDP/DDU Freight</el-menu-item> -->
        <el-menu-item index="/main/pricelist">FCL/DDP freight</el-menu-item>
        <el-menu-item index="/order/shippingOrder">Order</el-menu-item>
        <el-menu-item index="/order/tracking">Tracking</el-menu-item>
      </el-submenu>
      <el-submenu index="3">
        <template #title>Warehouse</template>
        <el-menu-item index="/warehouse/SKUManagement">Product</el-menu-item>
        <el-menu-item index="/warehouse/PreloadManagement">Box</el-menu-item>
        <el-menu-item index="/warehouse/Apply">Apply</el-menu-item>
        <el-menu-item index="/warehouse/InventoryStatistics">Inventory</el-menu-item>
        <el-menu-item index="/warehouse/CargoManagements">Transfer inventory</el-menu-item>
      </el-submenu>

      <el-submenu index="4">
        <template #title>DropShipping</template>
        <!-- <el-menu-item index="codropshipping">CoDropshipping</el-menu-item> -->
        <div
          class="meun-item"
          @click="goCodrop"
        >CoDropshipping</div>
        <el-menu-item index="/account/Shopify">Store</el-menu-item>
        <el-menu-item index="/account/storeOrder">Store Order</el-menu-item>
      </el-submenu>
      <el-menu-item index="/account/Bill">Billing</el-menu-item>
      <el-menu-item index="/aboutUs">About Us</el-menu-item>

      <div class="flex items-center absolute right-10  h-full">
        <div
          v-if="istoken"
          class="flex"
        >
          <div class="mr-4 p-1 cursor-pointer relative flex items-center select-none"
            ref="feedback">
            <span class="text-red-500 text-2xl bg-gray-600 px-2 py-1 rounded" @click.self="feedbackSwitch">Feedback</span> 
            <div v-show="feedbackMenu" class="dark:bg-darkMenu dark:text-gray-400 topSelect top-10 -right-24 sm:-right-4 p-2.5  w-470 text-13 cursor-default">
              <div v-show="!feedbackSuccess">
                <textarea rows="3" v-model="content" class="input text-13 resize-none"  @paste="handlePaste"></textarea>
                
                <Upload :images='images' @uploadImage='uploadImg'></Upload>
                <div class="mb-1.5">level</div>
                <el-rate
                  v-model="severity_level"
                  :colors="colors">
                </el-rate>
                <!-- <div class="mt-3 mb-1.5">Reply-to email</div>
                <input type="text" class="input text-13 py-1" v-model="email" disabled> -->
                <div class="mt-4 flex text-14 font-medium justify-end">
                  <button class="mr-2 py-1 px-2 bg-orange hover:bg-orange1 rounded-md text-white"
                  @click="sendFeedback">Send feedback</button>
                  <button class="py-1 px-2 bg-gray-100 hover:bg-gray-300 border border-gray-300 rounded-md text-gray-500"
                  @click="cancelFeedback">Cancel</button>
                </div>
              </div>
              <div v-show="feedbackSuccess" class="h-full flex justify-center items-center relative">
                <div v-show="feedbackLoading">
                  <img src="@/assets/loading.svg" class="w-20 h-20 animate-spin" alt="">
                </div>
                <div v-show="!feedbackLoading">
                  <img src="@/assets/thankFeedback.svg" class="w-24 h-24 mx-auto mb-5" alt="">
                  <div>Thank you for your feedback!</div>
                </div>
              </div>
            </div>
          </div>

          <Notice></Notice>

          <el-submenu index="5">
            <template #title>
              <div class="p-1 flex items-center">
                <div class="relative">
                  <img
                    :src="headImg"
                    class="mr-1 sm:mr-4 w-10 h-10 rounded-full"
                    alt=""
                  />
                  <img
                    v-if="superLevel == 'L1'"
                    src="@/assets/lv1.png"
                    class="absolute right-0 -bottom-1.5 w-7"
                    alt=""
                  >
                  <img
                    v-if="superLevel == 'L2'"
                    src="@/assets/lv2.png"
                    class="absolute right-0 -bottom-1.5 w-7"
                    alt=""
                  >
                </div>
                <div class="max-w-200 overflow-hidden whitespace-nowrap overflow-ellipsis mr-5">{{userName}}</div>
              </div>
            </template>
            <el-menu-item index="/account/wallet">Wallet</el-menu-item>
            <!-- <el-menu-item index="/account/profile">Profile</el-menu-item>
            <el-menu-item index="/account/changePassword">Password</el-menu-item> -->
            <el-menu-item index="/accountnav">Account</el-menu-item>
            <el-menu-item index="/main/issus">Feedback</el-menu-item>
            <el-menu-item index="/main/assessment">Assessment</el-menu-item>
            <el-menu-item index="/main/FBAwarehouse">FBA Warehouse Address</el-menu-item>
            <el-menu-item index="/login">Logout</el-menu-item>
          </el-submenu>
        </div>

        <div
          v-else
          class="mr-8"
        >
          <router-link :to="{ name: 'login' }">
            <button class="text-sm px-3 py-0.5 rounded bg-orange hover:bg-orange1 text-white">Log in</button>
          </router-link>
          <router-link :to="{ name: 'signUp' }">
            <button class="ml-3 text-sm px-3 py-0.5 rounded bg-orange hover:bg-orange1 text-white">Sign up</button>
          </router-link>
        </div>
      </div>
    </el-menu>
  </div>
</template>

<script>
import {
  feedback,
  feedbackSubmit,
  ImgUpload
} from '@/api/order'
import Upload from '@/components/upload';
import Notice from "./components/notice.vue";
export default {
  components: {
    Notice,
    Upload
  },
  data() {
    return {
      active: "/new/home",
      istoken: false,
      sinput: "",
      superLevel: "",
      userName: "",
      headImg: "",
      content: '',
      userName: '',
      images:[],
      severity_level: 0,
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      feedbackSuccess: false,
      feedbackLoading: false,
      feedbackMenu: false,
    };
  },
  created() {
    this.active = this.$route.path;

    if (this.$store.state.user.token) {
      this.istoken = true;
    } else {
      this.istoken = false;
    }
    if (this.istoken) {
      const userId = JSON.parse(localStorage.getItem("userId"));
      const headImg = JSON.parse(localStorage.getItem("userImg"));
      this.email = JSON.parse(localStorage.getItem("userInfo")).email;

      if (this.email == null) {
        this.headImg = require("../assets/moren.png");
      } else {
        this.headImg = headImg + userId + "_40_40.png";
      }
      let user = JSON.parse(localStorage.getItem("userInfo"));
      this.userName = user.first_name + " " + user.last_name;
      this.userID = user.id;
      this.superLevel = user.super_level;
      this.firstLogin = user.first_login;
    }
  },
  mounted() {
    document.addEventListener(
      'click',
      this.even,
      true
    )
  },
  destroyed() {  
    document.removeEventListener('click', this.even, true) 
  },
  methods: {
    goCodrop() {
      window.open("https://codropshipping.com/", "_blank");
    },
    async logout() {
      try {
        await this.$store.dispatch("userLogout");
        localStorage.removeItem("loginto");
        this.$router.push("/login");
        window.localStorage.clear();
      } catch (error) {}
    },
    handleSelect(key, keyPath) {
      if (key == "/login") {
        this.logout();
        return;
      }
      window.location.href = key;
    },
    feedbackSwitch() {
      // this.$refs.topMenu.style = 'z-index:41;'
      this.feedbackMenu = !this.feedbackMenu
      this.feedbackSuccess = false
    },
    handlePaste(event) {
      const items = (event.clipboardData || event.originalEvent.clipboardData).items;
      
      // 遍历所有粘贴项
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          // 如果是图片，则读取图片并上传
          const blob = items[i].getAsFile();
          this.uploadImg(blob);
          break;
        }
      }
      // 默认行为是粘贴文本
    },
    uploadImg(file){
      let data = new FormData()
      data.append('file', file);
      ImgUpload(data).then((res)=>{
        this.images = [];
        this.images.push(res.data.path)
      })
    },
    sendFeedback(){
      if(this.content != ''){
        feedbackSubmit({
          source: 2,
          type: window.location.href,
          content: this.content,
          severity_level: this.severity_level,
          images: this.images
        }).then((res)=>{
          if(res.code == 0){
            this.feedbackLoading = true
            this.feedbackSuccess = true
            setTimeout(()=>{
              this.feedbackLoading = false
              this.content = ''
              this.images = []
              this.severity_level = 0
            },800)
          }
        })
      }
    },
    cancelFeedback(){
      this.feedbackMenu = false
      this.content = ''
    },
    even(e){
      if(this.istoken){
        if (!this.$refs.feedback.contains(e.target)) {
          this.feedbackMenu = false
        }
      }
    },
  },
};
</script>

<style>
.meun-item {
  height: 36px;
  line-height: 36px;
  padding: 0 10px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.meun-item:hover {
  outline: 0;
  background-color: rgb(14, 38, 82);
}
</style>